import { render, staticRenderFns } from "./BankBook.vue?vue&type=template&id=8d1e56c4&"
import script from "./BankBook.vue?vue&type=script&lang=js&"
export * from "./BankBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports